import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import t from 'react-translate';
import ClickableContainer from 'components/clickable-container';

export enum CardStatus {
  REGISTER = 'register',
  UNREGISTER = 'unregister',
  STARTS_SOON = 'starts_soon',
  IN_PROGRESS = 'in_progress',
}

const statusTranslationKeys = {
  [CardStatus.REGISTER]: 'REGISTER',
  [CardStatus.UNREGISTER]: 'UNREGISTER',
  [CardStatus.STARTS_SOON]: 'STARTS_SOON',
  [CardStatus.IN_PROGRESS]: 'IN_PROGRESS',
};

type LiveSessionCardStateProps = {
  status?: CardStatus
  allowUserRegistration: boolean
  onClick: (state: CardStatus) => void
  requesting?: boolean
};

const LiveSessionCardState = (props: LiveSessionCardStateProps) => {
  const {
    status = CardStatus.UNREGISTER,
    allowUserRegistration,
    onClick,
    requesting = false,
  } = props;
  const [text, setText] = useState('');
  const translationPrefix = t.LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.MODAL.SESSION_CARD.STATE;

  useEffect(() => {
    const translationKey = statusTranslationKeys[status];
    let translation = translationPrefix[translationKey]();
    if (!allowUserRegistration && (status === CardStatus.REGISTER || status === CardStatus.UNREGISTER)) {
      translation = '';
    }
    if (status === CardStatus.UNREGISTER && requesting) {
      translation = t.LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.MODAL.SESSION_CARD.STATE.UNREGISTERING();
    }
    setText(translation);
  }, [status, requesting]);

  if (!text) {
    return null;
  }

  return (
    <div className='session-state text-gray-2 text-small bold text-align-center mt-2'>
      {status === CardStatus.UNREGISTER && allowUserRegistration ? (
        <ClickableContainer
          onClick={() => onClick(status)}
          disabled={requesting}
          className='text-primary font-weight-bold justify-content-center'
        >
          {text}
        </ClickableContainer>
      ) : (text)}
    </div>
  );
};

export default LiveSessionCardState;
